import React from 'react';
import { Container } from 'react-bootstrap';
import { FaCheck } from 'react-icons/fa';
import AdminPageHeader from './AdminPageHeader';

function AdminFormLayout({
  icon,
  eyebrow,
  title,
  description,
  breadcrumbs,
  actions,
  tipsTitle = 'Panduan Formulir',
  tips = [],
  fluid = true,
  containerClassName = 'admin-page-shell mt-4 px-4',
  children,
}) {
  return (
    <Container fluid={fluid} className={containerClassName}>
      <AdminPageHeader
        icon={icon}
        eyebrow={eyebrow}
        title={title}
        description={description}
        breadcrumbs={breadcrumbs}
        actions={actions}
      />

      <div className="form-layout-shell">
        <div className="section-card form-sheet">{children}</div>

        {tips.length > 0 ? (
          <aside className="form-aside">
            <div className="surface-card form-note-card">
              <span className="page-eyebrow">Quick Tips</span>
              <h2 className="form-note-card__title">{tipsTitle}</h2>
              <ul className="form-note-list">
                {tips.map(tip => (
                  <li key={tip} className="form-note-item">
                    <span className="form-note-item__icon">
                      <FaCheck />
                    </span>
                    <span>{tip}</span>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        ) : null}
      </div>
    </Container>
  );
}

export default AdminFormLayout;
